module.exports = __webpack_public_path__ + "img/close-white-18dp.4c8440d8.svg";